export type AudioTuningSettings = {
  backgroundVolume: number;
  revealCutoffSeconds: number;
  revealDelayMs: number;
  revealFadeOutMs: number;
  revealPlaybackRate: number;
  revealVolume: number;
  tapOneVolume: number;
  tapTwoVolume: number;
};

export const defaultAudioTuningSettings = {
  backgroundVolume: 0.07,
  revealCutoffSeconds: 6.65,
  revealDelayMs: 0,
  revealFadeOutMs: 180,
  revealPlaybackRate: 1,
  revealVolume: 1,
  tapOneVolume: 1,
  tapTwoVolume: 1,
} satisfies AudioTuningSettings;

// Transients in uncommon-reveal-timed.m4a used to synchronize the final two rewards.
export const doubleYellowRevealDingTimeSeconds = 2.9;
export const legendaryRevealChimeTimesSeconds = [3.83, 4.22, 4.65] as const;
